module.exports = __webpack_public_path__ + "img/287.76656a9c.jpg";